// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Root, Thumb } from '@radix-ui/react-switch';
import { withClassName } from '../../hooks/withClassName.js';
const SwitchRoot = withClassName(Root, 'unset w-42px h-25px bg-white rounded-lg relative transition-color border-default flex-shrink-0 focus-visible:shadow-focus [&[data-state=checked]]:bg-accent');
const SwitchThumb = withClassName(Thumb, 'block w-21px h-21px bg-white rounded-lg border-default transition-transform will-change-transform [&[data-state=checked]]:translate-x-19px');
export const Switch = Object.assign(function Switch(_a) {
    var { ref } = _a, props = __rest(_a, ["ref"]);
    return (_jsx(SwitchRoot, Object.assign({}, props, { ref: ref, children: _jsx(SwitchThumb, {}) })));
}, {
    Root: SwitchRoot,
    Thumb: SwitchThumb,
});
//# sourceMappingURL=Switch.js.map